<template>
  <div class="hospital-db-layout-header">
    <header-top></header-top>
    <div class="header-m-menu">
      <a-row>
        <a-col :span="4" class="hmm-title">Genemics Database</a-col>
        <a-col :span="16">
          <router-link to="/molecular" class="hmm-rlink action">首页</router-link>
          <!-- <router-link to="/" class="hmm-rlink">表达</router-link>
          <router-link to="/" class="hmm-rlink">管理</router-link>
          <router-link to="/" class="hmm-rlink">帮助</router-link> -->
        </a-col>
        <a-col :span="4" class="hmm-right">
          <!-- <a-input-search placeholder="请输入基因名称" class="hm-search" @search="onSearch" /> -->
          <div class="hm-search-content">
            <a-select class="hm-search" show-search :show-arrow="false" label-in-value :value="value"
              placeholder="请输入基因名称" :filter-option="false" :not-found-content="fetching ? undefined : null"
              @search="fetchGene" @change="handleChange">
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option v-for="d, index in optionData" :key="d">
                {{ d }}
              </a-select-option>
            </a-select>
            <a-icon class="hm-search-icon" type="search" />
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import HeaderTop from "@/components/wordbench/header";
import debounce from 'lodash/debounce';
export default {
  components: { HeaderTop },
  data() {
    this.lastFetchId = 0;
    this.fetchGene = debounce(this.fetchGene, 800);
    return {
      optionData: [],
      value: undefined,
      fetching: false,
    };
  },
  mounted() {

  },
  methods: {
    fetchGene(value) {
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.optionData = [];
      if (value) {
        this.fetching = true;
        this.$get("/gene/name/list", { gene: value })
          .then(res => {
            if (fetchId !== this.lastFetchId) {
              // for fetch callback order
              return;
            }
            this.optionData = res.data.data;
            this.fetching = false;
          });
      }
    },
    handleChange(value) {
      Object.assign(this, {
        value,
        optionData: [],
        fetching: false,
      });
      this.$router.push({ path: 'genomics', query: { name: value.key } })
    },
  }
};
</script>

<style lang="scss" scoped>
.header-m-menu {
  padding: 0 16px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.26);
  position: relative;
  z-index: 2;

  .hm-search-content {
    position: relative;

    .hm-search-icon {
      position: absolute;
      right: 6px;
      top: 17px;
    }
  }

  .hm-search {
    width: 230px;
    line-height: 47px;
    margin-top: 8px;
  }

  .hmm-title {
    font-size: 14px;
    line-height: 47px;
  }

  .hmm-right {
    text-align: right;
  }

  .hmm-rlink {
    line-height: 46px;
    display: inline-block;
    padding: 0 10px 0 10px;
    margin-right: 60px;
    color: #9b9b9b;

    &.action {
      color: #558cf0;
    }
  }
}
</style>